import { pr, React, RouteComponentProps, ui, observer, observable, george, debug, theme } from "aaa";
import { Document, Page } from "react-pdf";
import { history } from "stores/RouterStore";
import * as FileSaver from "file-saver";
import { config } from "config";
import { times } from "lodash";

@observer
export class PdfViewer extends React.Component<RouteComponentProps<{
    webUrl?: string
}> & {
    blob?: Blob,
    uint8Data?: Uint8Array,
    url?: string,
    onClose?: () => void
}, {}> {
    @observable scale = 1;
    @observable numPages = 1;

    handleDocumentLoadSuccess = (pdf: any) => {
        this.numPages = pdf?.pdfInfo?.numPages ?? 1;
    }

    handleDownload = async (url: string) => {
        try {
            const response = await fetch(url);
            const blob = await response.blob();
            FileSaver.saveAs(blob, "testpdf.pdf");

        } catch (error) {
            debug.log("### PdfViewer.handleDownload Failed", error);
        }
    }

    render() {
        let url = "";
        if (this.props.match.params.webUrl) {
            url = decodeURIComponent(this.props.match.params.webUrl);
        } else if (this.props.url) {
            url = this.props.url;
        } else if (this.props.blob) {
            url = URL.createObjectURL(this.props.blob);
        }

        if (!url && !this.props.uint8Data) {
            return null;
        }

        const HEADER_HEIGHT = 60;
        const iconStyle = {
            width: 40, height: 40, color: "white"
        };

        return (
            <div
                style={{
                    position: "relative",
                    width: "100%",
                    height: "100%"
                }}
            >
                <pr.HFlexCentered
                    style={{
                        position: "fixed",
                        background: "rgba(0,0,0,0.6)",
                        width: "100%",
                        height: HEADER_HEIGHT,
                        zIndex: 10,
                        maxWidth: theme.MAX_APP_WIDTH
                    }}
                >
                    {url ? (
                        <pr.IconDownload
                            style={{ ...iconStyle, flex: 1 }}
                            onClick={() => this.handleDownload(url)}
                        />
                    ) : (
                        <div style={{ flex: 1 }} />
                    )}
                    <pr.IconZoomOut
                        style={{ ...iconStyle, flex: 2 }}
                        onClick={() => this.scale -= 0.1}
                    />
                    <pr.IconZoomIn
                        style={{ ...iconStyle, flex: 2 }}
                        onClick={() => this.scale += 0.1}
                    />
                    <pr.IconClose
                        style={{ ...iconStyle, flex: 1 }}
                        onClick={() => this.props.onClose ? this.props.onClose() : history.goBack()}
                    />
                </pr.HFlexCentered>

                <div style={{ height: HEADER_HEIGHT }} />
                <Document
                    file={url ? url : { data: this.props.uint8Data }}
                    loading={<george.LoadingIndicator isLoading height={ui.windowHeight} />}
                    onLoadSuccess={this.handleDocumentLoadSuccess}
                >
                    {times(this.numPages, (pageNumber) => (
                        <Page
                            key={pageNumber + 1}
                            pageNumber={pageNumber + 1}
                            scale={this.scale}
                            loading={<george.LoadingIndicator isLoading height={ui.windowHeight} />}
                        />
                    ))}
                </Document>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/common/PdfViewer.tsx